module.exports = __webpack_public_path__ + "img/copy-icon.3a8463b3.svg";